__turbopack_context__.v({
  "bounce": "Select-module-scss-module__xWDs_G__bounce",
  "disabled": "Select-module-scss-module__xWDs_G__disabled",
  "error": "Select-module-scss-module__xWDs_G__error",
  "errorText": "Select-module-scss-module__xWDs_G__errorText",
  "fade-in": "Select-module-scss-module__xWDs_G__fade-in",
  "label": "Select-module-scss-module__xWDs_G__label",
  "open": "Select-module-scss-module__xWDs_G__open",
  "pulse": "Select-module-scss-module__xWDs_G__pulse",
  "rotated": "Select-module-scss-module__xWDs_G__rotated",
  "selectChevron": "Select-module-scss-module__xWDs_G__selectChevron",
  "selectContainer": "Select-module-scss-module__xWDs_G__selectContainer",
  "selectDropdown": "Select-module-scss-module__xWDs_G__selectDropdown",
  "selectGroup": "Select-module-scss-module__xWDs_G__selectGroup",
  "selectGroupLabel": "Select-module-scss-module__xWDs_G__selectGroupLabel",
  "selectGroup_dropdown": "Select-module-scss-module__xWDs_G__selectGroup_dropdown",
  "selectOption": "Select-module-scss-module__xWDs_G__selectOption",
  "selectOptionIndented": "Select-module-scss-module__xWDs_G__selectOptionIndented",
  "selectPlaceholder": "Select-module-scss-module__xWDs_G__selectPlaceholder",
  "selectTrigger": "Select-module-scss-module__xWDs_G__selectTrigger",
  "selectValue": "Select-module-scss-module__xWDs_G__selectValue",
  "selected": "Select-module-scss-module__xWDs_G__selected",
  "slide-in": "Select-module-scss-module__xWDs_G__slide-in",
  "slide-left": "Select-module-scss-module__xWDs_G__slide-left",
  "slide-right": "Select-module-scss-module__xWDs_G__slide-right",
});
